import type { PostingDiscoveryRow } from '@revelio/data-access';

import type { FullPostingInfoData } from './types';

const toNumber = (v: unknown, fallback = 0): number => {
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  if (typeof v === 'string') {
    const parsed = Number(v);
    if (Number.isFinite(parsed)) return parsed;
  }
  return fallback;
};

const toStringValue = (v: unknown): string => {
  if (typeof v === 'string') return v;
  if (typeof v === 'number') return String(v);
  return '';
};

export const transformRowToPostingData = (
  row: PostingDiscoveryRow
): FullPostingInfoData => {
  if (!row) return {};
  return {
    salary: toNumber(row.salary),
    jobType: toStringValue(row.remote_type),
    location: toStringValue(row.location),
    description: toStringValue(row.description),
    postedAt: toStringValue(row.post_date),
    url: toStringValue(row.posting_url),
  };
};
